var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('picture-chooser',{attrs:{"pictureName":"Voucherbild","pictures":_vm.pictures,"bucket":"voucher-pictures","context":"voucher-pictures"},on:{"savedNewPicture":_vm.pictureSaved,"saveSelectedPicture":_vm.saveSelectedPicture}})
}
var staticRenderFns = []

export { render, staticRenderFns }